import { useState, useCallback } from 'react';
import { useWindowEvent } from './hooks.mjs';
import { useIsomorphicEffect } from './use-isomorphic-effect.mjs';

const eventListenerOptions = { passive: true };
function useWindowSize() {
  const getSize = () => ({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0
  });
  const [windowSize, setWindowSize] = useState(getSize);
  const updateSize = useCallback(() => {
    setWindowSize(getSize());
  }, []);
  useWindowEvent("resize", updateSize, eventListenerOptions);
  useWindowEvent("orientationchange", updateSize, eventListenerOptions);
  useIsomorphicEffect(() => {
    updateSize();
  }, []);
  return windowSize;
}

export { useWindowSize };
